(function() {

	            var oldLoadScript = __webpack_require__.l;
	            var backupCdnHost = ["https://dep176-backup.gsf.netease.com","https://oc.oscar.netease.com/"];
	            var retryTimes = {};
	            __webpack_require__.l = function(url, done, key, chunkId){
	              try {
									function getNewUrl(url,backhost) {
										if (!url){
											return ''
										}
										if (/^http(s)?:\/\//.test(url)) {
											var UrlObj = new URL(url);
											return backhost + UrlObj.pathname + UrlObj.search + UrlObj.hash;
										} else if (/^\//.test(url)) {
											//根路径
											return backhost + url;
										} else {
											//相对路径，暂不支持
											console.error('[cdn auto retry] script src is relative path which is not surpport', url);
											return '';
										}
									}

	                function onScriptLoaded(event) {
	                  if (event&&event.type === 'load') {
	                    done(event)
	                    if(retryTimes[chunkId]) {
	                      delete retryTimes[chunkId]
	                    }
	                  } else {
	                    //加载失败，备用域名重试
	                    if (retryTimes[chunkId] === undefined) {
	                      retryTimes[chunkId] = 0
	                    } else {
	                      retryTimes[chunkId] += 1
	                    }
	                    var index = retryTimes[chunkId]
	                    if (backupCdnHost[index]) {
	                      oldLoadScript(getNewUrl(url,backupCdnHost[index]),onScriptLoaded,key,chunkId)
	                    } else {
	                      done(event)
	                    }
	                  }
	                }
	                oldLoadScript(url,onScriptLoaded,key,chunkId)
	              }catch(err) {
	                return oldLoadScript(url,done,key,chunkId)
	              }
	            }
})();